
// // src/pages/PaymentPage.js
// import React, { useEffect, useMemo, useState } from "react";
// import { FlutterWaveButton, closePaymentModal } from "flutterwave-react-v3";
// import { useLocation, useNavigate } from "react-router-dom";
// import "../styles/PaymentPage.css";
// import { clearUploadedFiles } from "../utils/FileCache";
// import axios from "axios";
// import api from "../api/apiClient";

// // Auto-fix any corrupted userEmail in localStorage
// (() => {
//   const val = localStorage.getItem("userEmail");
//   if (val && val.trim().startsWith("[")) {
//     try {
//       const parsed = JSON.parse(val);
//       if (Array.isArray(parsed) && parsed.length) {
//         localStorage.setItem("userEmail", parsed[0]);
//       } else {
//         localStorage.removeItem("userEmail");
//       }
//     } catch {
//       localStorage.removeItem("userEmail");
//     }
//   }
// })();

// /* ---------- Delivery pricing ---------- */
// const DELIVERY_PRICES = {
//   USA: {
//     usps_first_class_mail: 3,
//     usps_priority_mail: 9,
//     fedex_standard_overnight: 18,
//     ups_2nd_day_air: 13,
//   },
//   CANADA: {
//     usps_first_class_mail_international: 4,
//     usps_priority_mail_international: 12,
//     fedex_international_priority: 20,
//     ups_worldwide_saver: 15,
//   },
// };

// const recomputeTotal = (blocks = []) =>
//   blocks.reduce((total, block) => {
//     const country = block.address?.country || "USA";
//     const shipping = DELIVERY_PRICES[country]?.[block.deliveryMethod] || 0;
//     let blockTotal = 0;

//     if (block.type === "check") {
//       const checkCount = block.files?.length || 0;
//       if (checkCount > 0) blockTotal += shipping + checkCount * 3;
//     } else if (block.type === "document") {
//       const pages = (block.files || []).reduce((s, f) => s + (f.pageCount || 0), 0);
//       if (pages > 0) blockTotal += shipping + pages * 1;
//     } else if (block.type === "both") {
//       const checkCount = (block.files || []).filter((f) => f.pageCount === 1 && f.isDoc === false).length;
//       const pages = (block.files || []).filter((f) => f.isDoc === true).reduce((s, f) => s + (f.pageCount || 0), 0);
//       if (checkCount > 0 || pages > 0) blockTotal += shipping;
//       blockTotal += checkCount * 3 + pages * 1;
//     }
//     return total + blockTotal;
//   }, 0);

// /* ---------- Component ---------- */
// const PaymentPage = () => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const guestEmail = location.state?.guestEmail || "";

//   // Check if this session is guest mode
//   const isGuest = localStorage.getItem("guest") === "true";

//   const [dispatchInfo, setDispatchInfo] = useState(null);
//   const [currencyMode, setCurrencyMode] = useState("USD");
//   const [usdToNgnRate, setUsdToNgnRate] = useState(1600);
//   const [amountUSD, setAmountUSD] = useState(0);
//   const [amountToPay, setAmountToPay] = useState(0);
//   const [notification, setNotification] = useState({ type: "", message: "" });

//   useEffect(() => {
//     if (location.state) setDispatchInfo(location.state);
//   }, [location]);

//   useEffect(() => {
//     if (!dispatchInfo) return;
//     const incoming = Number(dispatchInfo.totalAmount || 0);
//     const fallback = recomputeTotal(dispatchInfo.dispatchBlocks || []);
//     const usd = Number.isFinite(incoming) && incoming > 0 ? incoming : fallback;
//     setAmountUSD(usd);
//   }, [dispatchInfo]);

//   useEffect(() => {
//     let mounted = true;
//     (async () => {
//       try {
//         const { data } = await axios.get(`${process.env.REACT_APP_API_BASE}/api/fx/usd-ngn`);
//         if (mounted && data?.rate) setUsdToNgnRate(Number(data.rate));
//       } catch {
//         /* fallback */
//       }
//     })();
//     return () => (mounted = false);
//   }, []);

//   useEffect(() => {
//     if (currencyMode === "USD" || currencyMode === "PAYPAL") {
//       setAmountToPay(amountUSD);
//     } else if (currencyMode === "NGN") {
//       setAmountToPay(Math.round(amountUSD * usdToNgnRate));
//     }
//   }, [currencyMode, amountUSD, usdToNgnRate]);

//   /* ---------- New unified pay + dispatch ---------- */
//   const handlePaymentSuccess = async (transactionId) => {
//     try {
//       const formData = new FormData();

//       formData.append("transaction_id", transactionId);

//       // formData.append("customerEmail", dispatchInfo?.email || "user@example.com");
//       // formData.append(
//       //   "customerEmail",
//       //   dispatchInfo?.email || localStorage.getItem("userEmail") || "user@example.com"
//       // );


//       formData.append("method", currencyMode === "PAYPAL" ? "Flutterwave-PayPal" : "Flutterwave");
//       formData.append("base_amount_usd", String(amountUSD));
//       formData.append("charged_currency", currencyMode === "NGN" ? "NGN" : "USD");
//       formData.append("charged_amount", String(amountToPay));

//       dispatchInfo.dispatchBlocks.forEach((block, index) => {
//         const shipmentKey = `shipment${index}`;
//         const documentsKey = `documents${index}`;
//         formData.append(
//           shipmentKey,
//           JSON.stringify({
//             type: block.type,
//             serviceCode: block.deliveryMethod,
//             recipientName: block.address?.name,
//             senderName: block.senderName,
//             recipientAddress: block.address?.line1,
//             recipientCity: block.address?.city,
//             recipientState: block.address?.state,
//             recipientZip: block.address?.zip,
//             recipientPhone: block.address?.phone,
//             country: block.address?.country,
//             mailDate: dispatchInfo.mailDate,
//           })
//         );

//         if (block.files?.length > 0) {
//           block.files.forEach((fileObj) => {
//             formData.append(documentsKey, fileObj.file, fileObj.name);
//           });
//         }
//       });

//       // ✅ Direct call to your real backend
//       // const res = await fetch(`${process.env.REACT_APP_API_BASE}/api/payment/pay-and-dispatch`, {
//       //   method: "POST",
//       //   body: formData,
//       // });

//       const isGuest = localStorage.getItem("guest") === "true";

//       if (isGuest) {
//         formData.append("guest", true);
//         formData.append("customerEmail", guestEmail || "guest@cjetdispatch.com");
//       } else {
//         const userEmail = localStorage.getItem("userEmail");
//         formData.append("customerEmail", userEmail || "unknown@cjetdispatch.com");
//       }

//       // ✅ Use axios (apiClient)
//       const { data: result } = await api.post("/api/payment/pay-and-dispatch", formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       if (result.success) {
//         clearUploadedFiles();

//         // Small delay before navigation
//         await new Promise((r) => setTimeout(r, 200));

//         navigate("/success", {
//           state: { results: result.results || result.successful },
//         });
//       } else {
//         setNotification({
//           type: "error",
//           message: "Payment verified, but dispatch failed. Please contact support.",
//         });
//       }
//     } catch (err) {
//       console.error("❌ Error in pay-and-dispatch:", err);
//       setNotification({
//         type: "error",
//         message:
//           err.response?.data?.message ||
//           (err.message?.includes("unexpected") || err.message?.includes("Server")
//             ? "Your payment was processed, but we couldn't confirm shipment yet. Please refresh or check your email shortly."
//             : err.message || "An unexpected error occurred. Please retry."),
//       });
//     }
//   };

//   const customerEmail = dispatchInfo?.email || localStorage.getItem("userEmail") || "user@example.com";

//   const config = useMemo(() => {
//     const base = {
//       public_key: process.env.REACT_APP_FLW_PUBLIC_KEY,

//       tx_ref: `${Date.now()}-${amountToPay}-${Math.random().toString(36).slice(2, 8)}`,

//       // tx_ref: `${Date.now()}-${amountToPay}`,
//       amount: amountToPay,
//       customer: {
//         email: customerEmail,
//         name: "Customer",
//         phonenumber: "07000000000",
//       },
//       customizations: {
//         title: "Cjet Dispatch Payment",
//         description: "Multiple dispatches",
//         logo: "/logo192.png",
//       },
//     };

//     if (currencyMode === "NGN") return { ...base, currency: "NGN", payment_options: "card,ussd,banktransfer" };
//     if (currencyMode === "PAYPAL") return { ...base, currency: "USD", payment_options: "paypal" };
//     return { ...base, currency: "USD", payment_options: "card" };
//   }, [amountToPay, customerEmail, currencyMode]);

//   const fwConfig = {
//     ...config,
//     text: "Pay Now",
//     callback: async (response) => {
//       console.log("🎉 Payment callback:", response);
//       if (response.status === "successful" && response.transaction_id) {
//         await handlePaymentSuccess(response.transaction_id);
//       } else {
//         setNotification({
//           type: "error",
//           message: "Payment was not successful. Please try again or use another method.",
//         });
//       }
//       closePaymentModal();
//     },
//     onClose: () => console.log("💨 Payment modal closed."),
//   };

//   if (!dispatchInfo) return <p className="loading">Loading payment data...</p>;
//   if (!config.public_key) console.warn("⚠️ Flutterwave public key not found!");

//   const prettyAmount = currencyMode === "NGN"
//     ? `₦${amountToPay.toLocaleString()}`
//     : `$${amountToPay.toFixed(2)}`;

//   /* ---------- Same design preserved ---------- */
//   return (
//     <div className="payment-page-root">
//       {notification.message && (
//         <div className={`notification-banner ${notification.type}`}>
//           <span>{notification.message}</span>
//           <button onClick={() => setNotification({ type: "", message: "" })}>×</button>
//         </div>
//       )}

//       <div className="payment-hero">
//         <div className="payment-hero-left">
//           <h1>Secure Checkout</h1>
//           <p className="muted">
//             Pay for your dispatches securely. Review order and choose preferred payment method.
//           </p>

//           <div className="order-card">
//             <div className="order-card-header">
//               <strong>Order summary</strong>
//               <span className="small-muted">
//                 {dispatchInfo.dispatchBlocks.length} dispatch
//                 {dispatchInfo.dispatchBlocks.length > 1 ? "es" : ""}
//               </span>
//             </div>

//             <div className="order-items">
//               {dispatchInfo.dispatchBlocks.map((b, i) => (
//                 <div key={i} className="order-item">
//                   <div>
//                     <div className="order-item-title">
//                       Dispatch #{i + 1} • {b.type || "—"}
//                     </div>
//                     <div className="small-muted">
//                       {b.address?.name || "No recipient"} — {b.address?.city || "—"}
//                     </div>
//                   </div>
//                   <div className="order-item-price">
//                     ${(() => {
//                       const country = b.address?.country || "USA";
//                       const shipping = DELIVERY_PRICES[country]?.[b.deliveryMethod] || 0;
//                       let blockTotal = 0;
//                       if (b.type === "check") {
//                         blockTotal += shipping + (b.files?.length || 0) * 3;
//                       } else if (b.type === "document") {
//                         const pages = (b.files || []).reduce((s, f) => s + (f.pageCount || 0), 0);
//                         blockTotal += shipping + pages * 1;
//                       } else if (b.type === "both") {
//                         const checkCount = (b.files || []).filter((f) => f.pageCount === 1 && f.isDoc === false).length;
//                         const pages = (b.files || []).filter((f) => f.isDoc === true).reduce((s, f) => s + (f.pageCount || 0), 0);
//                         blockTotal += shipping + checkCount * 3 + pages * 1;
//                       }
//                       return blockTotal.toFixed(2);
//                     })()}
//                   </div>
//                 </div>
//               ))}
//             </div>

//             <div className="order-totals">
//               <div className="totals-row"><span>Subtotal</span><span>${amountUSD.toFixed(2)}</span></div>
//               <div className="totals-row"><span>Currency</span><span>{currencyMode === "NGN" ? "NGN" : "USD"}</span></div>
//               <div className="totals-row grand-total"><strong>Total</strong><strong>{prettyAmount}</strong></div>
//             </div>
//           </div>

//           <div className="help-block">
//             <strong>Need help?</strong>
//             <p className="small-muted">
//               Contact support at <a href="mailto:support@cjetdispatch.com">support@cjetdispatch.com</a>
//             </p>
//           </div>
//         </div>

//         <aside className="payment-hero-right">
//           <div className="payment-panel">
//             <div className="payment-panel-head">
//               <div>
//                 <small className="muted">You pay</small>
//                 <div className="payment-amount-large">{prettyAmount}</div>
//               </div>
//               <div className="payment-currency-chips">
//                 <button className={`currency-chip ${currencyMode === "USD" ? "active" : ""}`} onClick={() => setCurrencyMode("USD")}>USD</button>
//                 <button className={`currency-chip ${currencyMode === "NGN" ? "active" : ""}`} onClick={() => setCurrencyMode("NGN")}>NGN</button>
//                 <button className={`currency-chip ${currencyMode === "PAYPAL" ? "active" : ""}`} onClick={() => setCurrencyMode("PAYPAL")}>PayPal</button>
//               </div>
//             </div>

//             <div className="payment-actions">
//               <FlutterWaveButton
//                 key={`fw-${currencyMode}-${amountToPay}`}
//                 {...fwConfig}
//                 className="flutterwave-button-custom"
//               />
//               <div className="alt-pay-note">
//                 <small className="muted">Secure payments powered by Flutterwave</small>
//               </div>
//             </div>

//             <div className="payment-meta">
//               <div className="meta-row"><strong>Payment email</strong><span>{customerEmail}</span></div>
//               <div className="meta-row"><strong>Amount (base USD)</strong><span>${amountUSD.toFixed(2)}</span></div>
//               <div className="meta-row"><strong>FX rate</strong><span>1 USD = {usdToNgnRate} NGN</span></div>
//             </div>
//           </div>
//         </aside>
//       </div>
//     </div>
//   );
// };

// export default PaymentPage;






// src/pages/PaymentPage.js
import React, { useMemo, useState, useEffect } from "react";
import { FlutterWaveButton, closePaymentModal } from "flutterwave-react-v3";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/PaymentPage.css";
import { clearUploadedFiles } from "../utils/FileCache";
import axios from "axios";
import api from "../api/apiClient";

// Auto-fix any corrupted userEmail in localStorage
(() => {
  const val = localStorage.getItem("userEmail");
  if (val && val.trim().startsWith("[")) {
    try {
      const parsed = JSON.parse(val);
      if (Array.isArray(parsed) && parsed.length) {
        localStorage.setItem("userEmail", parsed[0]);
      } else {
        localStorage.removeItem("userEmail");
      }
    } catch {
      localStorage.removeItem("userEmail");
    }
  }
})();

/* ---------- Delivery pricing ---------- */
const DELIVERY_PRICES = {
  USA: {
    usps_first_class_mail: 3,
    usps_priority_mail: 9,
    fedex_standard_overnight: 18,
    ups_2nd_day_air: 13,
  },
  CANADA: {
    usps_first_class_mail_international: 4,
    usps_priority_mail_international: 12,
    fedex_international_priority: 20,
    ups_worldwide_saver: 15,
  },
};

const recomputeTotal = (blocks = []) =>
  blocks.reduce((total, block) => {
    const country = block.address?.country || "USA";
    const shipping = DELIVERY_PRICES[country]?.[block.deliveryMethod] || 0;
    let blockTotal = 0;

    if (block.type === "check") {
      const checkCount = block.files?.length || 0;
      if (checkCount > 0) blockTotal += shipping + checkCount * 3;
    } else if (block.type === "document") {
      const pages = (block.files || []).reduce((s, f) => s + (f.pageCount || 0), 0);
      if (pages > 0) blockTotal += shipping + pages * 1;
    } else if (block.type === "both") {
      const checkCount = (block.files || []).filter((f) => f.pageCount === 1 && f.isDoc === false).length;
      const pages = (block.files || []).filter((f) => f.isDoc === true).reduce((s, f) => s + (f.pageCount || 0), 0);
      if (checkCount > 0 || pages > 0) blockTotal += shipping;
      blockTotal += checkCount * 3 + pages * 1;
    }
    return total + blockTotal;
  }, 0);

/* ---------- Component ---------- */
const PaymentPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const guestEmail = location.state?.guestEmail || "";
  const dispatchInfo = location.state;
  const isGuest = localStorage.getItem("guest") === "true";
  const [currencyMode, setCurrencyMode] = useState("USD");
  const [usdToNgnRate, setUsdToNgnRate] = useState(1600);
  const [notification, setNotification] = useState({ type: "", message: "" });

  // Recompute total from raw dispatch every render
  const canonicalUSD = useMemo(() => {
    return recomputeTotal(dispatchInfo?.dispatchBlocks || []);
  }, [dispatchInfo]);

  const amountToPay = useMemo(() => {
    if (currencyMode === "NGN") return Math.round(canonicalUSD * usdToNgnRate);
    return canonicalUSD;
  }, [currencyMode, canonicalUSD, usdToNgnRate]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await axios.get(`${process.env.REACT_APP_API_BASE}/api/fx/usd-ngn`);
        if (mounted && data?.rate) setUsdToNgnRate(Number(data.rate));
      } catch {
        /* fallback */
      }
    })();
    return () => (mounted = false);
  }, []);

  const txRef = useMemo(
    () => `${Date.now()}-${currencyMode}-${amountToPay}-${Math.random().toString(36).slice(2, 8)}`,
    [currencyMode, amountToPay]
  );

  const handlePaymentSuccess = async (transactionId) => {
    try {
      const formData = new FormData();
      formData.append("transaction_id", transactionId);
      formData.append("method", currencyMode === "PAYPAL" ? "Flutterwave-PayPal" : "Flutterwave");
      formData.append("base_amount_usd", String(canonicalUSD));
      formData.append("charged_currency", currencyMode === "NGN" ? "NGN" : "USD");
      formData.append("charged_amount", String(amountToPay));
      formData.append("tx_ref", txRef);

      if (isGuest) {
        formData.append("guest", true);
        formData.append("customerEmail", guestEmail || "guest@cjetdispatch.com");
      } else {
        const userEmail = localStorage.getItem("userEmail");
        formData.append("customerEmail", userEmail || "unknown@cjetdispatch.com");
      }

      dispatchInfo.dispatchBlocks.forEach((block, index) => {
        const shipmentKey = `shipment${index}`;
        const documentsKey = `documents${index}`;
        formData.append(
          shipmentKey,
          JSON.stringify({
            type: block.type,
            serviceCode: block.deliveryMethod,
            recipientName: block.address?.name,
            senderName: block.senderName,
            recipientAddress: block.address?.line1,
            recipientCity: block.address?.city,
            recipientState: block.address?.state,
            recipientZip: block.address?.zip,
            recipientPhone: block.address?.phone,
            country: block.address?.country,
            mailDate: dispatchInfo.mailDate,
          })
        );

        if (block.files?.length > 0) {
          block.files.forEach((fileObj) => {
            formData.append(documentsKey, fileObj.file, fileObj.name);
          });
        }
      });

      const { data: result } = await api.post("/api/payment/pay-and-dispatch", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (result.success) {
        clearUploadedFiles();
        await new Promise((r) => setTimeout(r, 200));
        navigate("/success", {
          state: { results: result.results || result.successful },
        });
      } else {
        setNotification({
          type: "error",
          message: "Payment verified, but dispatch failed. Please contact support.",
        });
      }
    } catch (err) {
      console.error("❌ Error in pay-and-dispatch:", err);
      setNotification({
        type: "error",
        message:
          err.response?.data?.message ||
          (err.message?.includes("unexpected") || err.message?.includes("Server")
            ? "Your payment was processed, but we couldn't confirm shipment yet. Please refresh or check your email shortly."
            : err.message || "An unexpected error occurred. Please retry."),
      });
    }
  };

  const customerEmail =
    dispatchInfo?.email || localStorage.getItem("userEmail") || "user@example.com";

  const config = useMemo(() => {
    const base = {
      public_key: process.env.REACT_APP_FLW_PUBLIC_KEY,
      tx_ref: txRef,
      amount: amountToPay,
      customer: { email: customerEmail, name: "Customer", phonenumber: "07000000000" },
      customizations: {
        title: "Cjet Dispatch Payment",
        description: "Multiple dispatches",
        logo: "/logo192.png",
      },
    };
    if (currencyMode === "NGN")
      return { ...base, currency: "NGN", payment_options: "card,ussd,banktransfer" };
    if (currencyMode === "PAYPAL")
      return { ...base, currency: "USD", payment_options: "paypal" };
    return { ...base, currency: "USD", payment_options: "card" };
  }, [txRef, amountToPay, customerEmail, currencyMode]);

  const fwConfig = {
    ...config,
    text: "Pay Now",
    callback: async (response) => {
      console.log("🎉 Payment callback:", response);
      if (response.status === "successful" && response.transaction_id) {
        await handlePaymentSuccess(response.transaction_id);
      } else {
        setNotification({
          type: "error",
          message: "Payment was not successful. Please try again or use another method.",
        });
      }
      closePaymentModal();
    },
    onClose: () => console.log("💨 Payment modal closed."),
  };

  const prettyAmount =
    currencyMode === "NGN"
      ? `₦${amountToPay.toLocaleString()}`
      : `$${amountToPay.toFixed(2)}`;

  if (!dispatchInfo) return <p className="loading">Loading payment data...</p>;

  return (
    <div className="payment-page-root">
      {notification.message && (
        <div className={`notification-banner ${notification.type}`}>
          <span>{notification.message}</span>
          <button onClick={() => setNotification({ type: "", message: "" })}>×</button>
        </div>
      )}

      <div className="payment-hero">
        <div className="payment-hero-left">
          <h1>Secure Checkout</h1>
          <p className="muted">
            Pay for your dispatches securely. Review order and choose preferred payment method.
          </p>

          <div className="order-card">
            <div className="order-card-header">
              <strong>Order summary</strong>
              <span className="small-muted">
                {dispatchInfo.dispatchBlocks.length} dispatch
                {dispatchInfo.dispatchBlocks.length > 1 ? "es" : ""}
              </span>
            </div>

            <div className="order-items">
              {dispatchInfo.dispatchBlocks.map((b, i) => (
                <div key={i} className="order-item">
                  <div>
                    <div className="order-item-title">
                      Dispatch #{i + 1} • {b.type || "—"}
                    </div>
                    <div className="small-muted">
                      {b.address?.name || "No recipient"} — {b.address?.city || "—"}
                    </div>
                  </div>
                  <div className="order-item-price">
                    ${(() => {
                      const country = b.address?.country || "USA";
                      const shipping = DELIVERY_PRICES[country]?.[b.deliveryMethod] || 0;
                      let blockTotal = 0;
                      if (b.type === "check") {
                        blockTotal += shipping + (b.files?.length || 0) * 3;
                      } else if (b.type === "document") {
                        const pages = (b.files || []).reduce((s, f) => s + (f.pageCount || 0), 0);
                        blockTotal += shipping + pages * 1;
                      } else if (b.type === "both") {
                        const checkCount = (b.files || []).filter((f) => f.pageCount === 1 && f.isDoc === false).length;
                        const pages = (b.files || []).filter((f) => f.isDoc === true).reduce((s, f) => s + (f.pageCount || 0), 0);
                        blockTotal += shipping + checkCount * 3 + pages * 1;
                      }
                      return blockTotal.toFixed(2);
                    })()}
                  </div>
                </div>
              ))}
            </div>

            <div className="order-totals">
              <div className="totals-row"><span>Subtotal</span><span>${canonicalUSD.toFixed(2)}</span></div>
              <div className="totals-row"><span>Currency</span><span>{currencyMode}</span></div>
              <div className="totals-row grand-total"><strong>Total</strong><strong>{prettyAmount}</strong></div>
            </div>
          </div>

          <div className="help-block">
            <strong>Need help?</strong>
            <p className="small-muted">
              Contact support at <a href="mailto:support@cjetdispatch.com">support@cjetdispatch.com</a>
            </p>
          </div>
        </div>

        <aside className="payment-hero-right">
          <div className="payment-panel">
            <div className="payment-panel-head">
              <div>
                <small className="muted">You pay</small>
                <div className="payment-amount-large">{prettyAmount}</div>
              </div>
              <div className="payment-currency-chips">
                <button className={`currency-chip ${currencyMode === "USD" ? "active" : ""}`} onClick={() => setCurrencyMode("USD")}>USD</button>
                <button className={`currency-chip ${currencyMode === "NGN" ? "active" : ""}`} onClick={() => setCurrencyMode("NGN")}>NGN</button>
                <button className={`currency-chip ${currencyMode === "PAYPAL" ? "active" : ""}`} onClick={() => setCurrencyMode("PAYPAL")}>PayPal</button>
              </div>
            </div>

            <div className="payment-actions">
              <FlutterWaveButton
                key={`fw-${currencyMode}-${amountToPay}-${txRef}`}
                {...fwConfig}
                className="flutterwave-button-custom"
              />
              <div className="alt-pay-note">
                <small className="muted">Secure payments powered by Flutterwave</small>
              </div>
            </div>

            <div className="payment-meta">
              <div className="meta-row"><strong>Payment email</strong><span>{customerEmail}</span></div>
              <div className="meta-row"><strong>Amount (base USD)</strong><span>${canonicalUSD.toFixed(2)}</span></div>
              <div className="meta-row"><strong>FX rate</strong><span>1 USD = {usdToNgnRate} NGN</span></div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default PaymentPage;